import React from 'react';
import { slider } from '../../Advantages/Slider';
import { adobeTrack } from '../../../utils';
import { withContent } from '../../../hoc/withContext';
import IContent from '../../../types/content';
interface ITabProps {
  title: number;
  currentSlide: number;
  timeout: number;
  gameTitle: string;
  context?: IContent;
}

const SliderTab: React.FunctionComponent<ITabProps> = ({ title, timeout,currentSlide,gameTitle,context}) => {
  const animationDuration = timeout / 1000;
  window.onscroll = function(){

    let sliderElement = document.querySelector('.advantages-wrapper');
    if(sliderElement.getBoundingClientRect().top <= 0){
      for (let i = 0; i < document.getElementsByClassName("progress-bar-enable").length; i++) {
        document.getElementsByClassName("progress-bar-enable")[i].classList.add("progress-bar_inner");
      }
    }
  }

  //Changes the current tab to the clicked tab and tracks the user
  function handleCLick(gameTitle:string , currentTab:number){
    adobeTrack('clickevent', `${context.tracking.slider_click} ${gameTitle}`)
    slider.slickGoTo(currentTab)
  }

  return (
    <div className="slide-navigation__tab"  onClick={() => handleCLick(gameTitle,title)}>
      <span  className="title" style={(title === currentSlide) ? {width: "100px"} : {width:"60px"}}/>
      <div className="progress-bar">
        <div
          style={{ animationDuration: animationDuration + 's' }}
          className={'progress-bar-enable'}
        />
      </div>
    </div>
  );
};

export default  withContent(SliderTab);
